import styled from "styled-components";

const colorLookup = {
  green: "#008A00" /* Source colour code: secondary5 */,
  orange: "#FECB00" /* Source colour code: secondary2 */,
  amber: "#FECB00" /* Source colour code: secondary2 */,
  red: "#E60000" /* Source color code: secondary7 */,
};

export const CircleColorKey = styled.div<{
  color: "green" | "amber" | "red" | "orange";
}>`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ color }) => colorLookup[color]};
`;
